import { Head, Link, useForm } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { DashboardLayout } from '@/layouts/DashboardLayout'
import { batchesPath } from '@/lib/routes'

import { BatchFormFields, type BatchFormData } from './_Form'

function BatchesNew() {
  const form = useForm<BatchFormData>({
    code: '',
    year: '',
    period: '',
  })

  return (
    <>
      <Head title="New batch" />

      <div className="mx-auto max-w-3xl px-8 py-10">
        <Link
          href={batchesPath()}
          className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to batches
        </Link>

        <PageHeader title="New batch" description="Add a new cohort." />

        <form
          onSubmit={(event) => {
            event.preventDefault()
            form.transform((data) => ({ batch: data }))
            form.post(batchesPath())
          }}
        >
          <BatchFormFields
            data={form.data}
            errors={form.errors as Partial<Record<keyof BatchFormData, string>>}
            setData={form.setData}
          />

          <div className="mt-6 flex justify-end gap-2">
            <Link href={batchesPath()}>
              <Button type="button" variant="ghost">
                Cancel
              </Button>
            </Link>
            <Button type="submit" disabled={form.processing}>
              {form.processing ? 'Saving…' : 'Create batch'}
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

export default Object.assign(BatchesNew, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
